import { createVStack } from '@gluestack-ui/vstack';
import { Root } from './styled-components';
export const VStack = createVStack({
    Root,
});
